const SSO_INITIATE_PATH = '/api/auth/v2/initiate/sso';

export function buildSsoInitiateUrl(redirectPath: string | null): string {
  if (!redirectPath) {
    return SSO_INITIATE_PATH;
  }

  const searchParams = new URLSearchParams({ redirect: redirectPath });
  return `${SSO_INITIATE_PATH}?${searchParams.toString()}`;
}
